module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.value), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n                                " + _vm._s(item.eventName) + "\n\n                            ")]), _vm._v(" "), _c('td', [_c('label', {
      attrs: {
        "for": "itemEnabledCheckbox"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.enabled),
        expression: "item.enabled"
      }],
      attrs: {
        "type": "checkbox",
        "id": "itemEnabledCheckbox"
      },
      domProps: {
        "checked": Array.isArray(item.enabled) ? _vm._i(item.enabled, null) > -1 : (item.enabled)
      },
      on: {
        "change": function($event) {
          var $$a = item.enabled,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "enabled", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "enabled", $$c)
          }
        }
      }
    }), _vm._v("\n                                    Enabled\n                                ")])]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "list-unstyled"
    }, _vm._l((item.emailRecipients), function(recipient) {
      return _c('li', [_vm._v("\n                                        " + _vm._s(recipient) + "\n                                        "), _c('button', {
        staticClass: "btn btn-sm pull-right",
        on: {
          "click": function($event) {
            return _vm.onRemoveRecipientClick(item.eventName, recipient)
          }
        }
      }, [_vm._v("Remove")])])
    }), 0)]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.customMessage),
        expression: "item.customMessage"
      }],
      staticClass: "form-control",
      attrs: {
        "rows": "3",
        "placeholder": "Comments to be appended to the email.  Use <br> for line breaks"
      },
      domProps: {
        "value": (item.customMessage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "customMessage", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.onAddRecipientClick(item)
        }
      }
    }, [_vm._v("Add Recipient...")])])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticStyle: {
      "width": "17%"
    },
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "28%"
    },
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "span": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("\n                                Event\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Enabled\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Recipients\n                            ")]), _vm._v(" "), _c('th', [_vm._v("\n                                User Comments\n                                ")]), _vm._v(" "), _c('th', [_vm._v("\n                                Options\n                            ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-306ab058", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-306ab058"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/event-notifications-editor-dialog/event-notifications-editor-dialog.vue.html
// module id = 1091
// module chunks = 0